import { changeTeamProjectSorting } from './changeTeamProjectSorting'
import { changeTeamSorting } from './changeTeamSorting'
import { isOrganizationsEntityType } from './prepareCustomSortingGridFilter'

type SyncCustomSortingParams = {
  entityType?: string
  teamId: string
  itemsIds: string[]
}

export const syncCustomSorting = ({
  entityType,
  teamId,
  itemsIds,
}: SyncCustomSortingParams) => {
  if (isOrganizationsEntityType(entityType)) {
    return changeTeamSorting({ teamId, itemsIds })
  }

  return changeTeamProjectSorting({ teamId, itemsIds })
}
import { changeTeamProjectSorting } from './changeTeamProjectSorting'
import { changeTeamSorting } from './changeTeamSorting'
import { isOrganizationsEntityType } from './prepareCustomSortingGridFilter'

type SyncCustomSortingParams = {
  entityType?: string
  teamId: string
  itemsIds: string[]
}

export const syncCustomSorting = ({
  entityType,
  teamId,
  itemsIds,
}: SyncCustomSortingParams) => {
  if (isOrganizationsEntityType(entityType)) {
    return changeTeamSorting({ teamId, itemsIds })
  }

  return changeTeamProjectSorting({ teamId, itemsIds })
}
